// Globals
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

// Store
import { useAppDispatch, useAppState } from '@/store';
import { getProperties, getProperty, propertiesSelector, selectAppliedFilters, setProperty } from '../../feature';

// Components
import PropertiesTable from '../../components/PropertiesTable/PropertiesTable';
import PropertiesFiltersContainer from '../PropertiesFiltersContainer/PropertiesFiltersContainer';
import PropertyDetailsContainer from '../PropertyDetailsContainer/PropertyDetailsContainer';
import {
  StyledContentBlock,
  StyledDrawer,
  StyledHeaderBlock,
  StyledPageTitle,
  StyledPageWrapper,
} from './PropertiesContainerStyles';

// Modules
import { resetDocumentsState } from '@/modules/PropertyDocuments';

// Helpers
import { GetPropertiesDTO } from '../../dtos';
import { useGetProperties, useGetPropertyDetails } from '../../hooks';

const PropertiesContainer = () => {
  const { t } = useTranslation('property');
  const { isLoading, properties, pagination, itemsCount } = useAppState(propertiesSelector);
  const appliedFilters = useAppState(selectAppliedFilters);
  const dispatch = useAppDispatch();

  const [queryParams, setQueryParams] = useSearchParams();

  useGetProperties();
  const property = useGetPropertyDetails(queryParams.get('id'));

  const handleChangePage = (value: { cursor?: string; limit?: number }) => {
    const dto = new GetPropertiesDTO({
      ...appliedFilters,
      ...value,
    });

    dispatch(getProperties(dto));
  };

  const handleClose = () => {
    dispatch(setProperty(null));
    dispatch(resetDocumentsState());
    setQueryParams({});
  };

  const handleSelectProperty = (id: string) => {
    setQueryParams({ id });
    dispatch(getProperty(id));
  };

  return (
    <StyledPageWrapper>
      <StyledHeaderBlock>
        <StyledPageTitle>{t('properties_in_progress_title', { count: itemsCount })}</StyledPageTitle>
      </StyledHeaderBlock>
      <StyledContentBlock>
        <PropertiesTable
          isLoading={isLoading}
          data={properties ?? []}
          onPageChange={handleChangePage}
          onRowClick={handleSelectProperty}
          pagination={pagination ?? {}}
          header={PropertiesFiltersContainer}
        />
      </StyledContentBlock>
      <StyledDrawer
        title={property?.address?.full_address ?? ''}
        width="68rem"
        open={!!property}
        onClose={handleClose}
        destroyOnClose
      >
        <PropertyDetailsContainer />
      </StyledDrawer>
    </StyledPageWrapper>
  );
};

export default PropertiesContainer;
